import { Footer, Header, Sidebar } from '../';
import styled from 'styled-components';
import { Outlet } from 'react-router';

const StyledContainer = styled.div`
  background: rgb(250, 251, 253);
  min-height: 100vh;
  height: auto;
  overflow-x: hidden;
  width: 100vw;
`;

const StyledChildren = styled.div`
  padding: 90px 0 0 0;
  margin-left: 200px;
  min-height: calc(100vh - 16px);
  margin-bottom: 16px;
  width: calc(100% - 200px);
`;

export const ApplicationShell = ({ children }) => {
  return (
    <StyledContainer className='bulldog-app'>
      <Header />

      <Sidebar />

      <StyledChildren>{children}</StyledChildren>

      <Footer />
    </StyledContainer>
  );
};
